import { CdkStepper } from '@angular/cdk/stepper';
import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
})
export class StepperComponent extends CdkStepper implements OnInit {
  @Output() cancelRequest = new EventEmitter();
  @Output() saveRequest = new EventEmitter();

  @Input() resetView!: Observable<void>;
  @Input() stepsIndex!: number[];
  @Input() canContinue = true;

  public currentDisplayedStep = 1;

  public get value() {
    return 100 / (this.stepsIndex.length / this.currentDisplayedStep);
  }

  ngOnInit(): void {
    this.resetView.subscribe(() => {
      this.currentDisplayedStep = 1;
      this.selectedIndex = 0;
    });
  }

  selectNextStep(): void {
    this.selectedIndex = this.stepsIndex[this.stepsIndex.indexOf(this.selectedIndex) + 1];
    this.currentDisplayedStep += 1;
  }

  cancel(): void {
    this.cancelRequest.emit();
  }

  save(): void {
    this.saveRequest.emit();
  }
}
